import React from 'react';
import { routesPathsToNames } from '../../routes';
import { Crumb } from './Crumb';
import style from './Breadcrumbs.module.scss';

interface IProps {
	path: string;
}

export const Breadcrumbs: React.FC<IProps> = ({ path }) => {
	if (path === '/home') {
		return null;
	}

	const sections = path.slice(1).split('/');
	const crumbs = sections.map((name) => {
		const crumbPath = path.substring(0, path.indexOf(name) + name.length);
		return {
			path: crumbPath,
			label: routesPathsToNames.get(crumbPath) || name,
		};
	});

	return (
		<div className={style.wrapperBreadcrumbs} data-test="Breadcrumbs">
			{crumbs.map((crumb, index) => {
				const active = crumb.path === path;
				return (
					<div className={style.linkWrapper} key={index}>
						{index > 0 ? <span className={style.separator}>/</span> : null}
						<Crumb crumb={crumb} active={active} />
					</div>
				);
			})}
		</div>
	);
};
